import { useState } from 'react';
import ConnectModal from './ConnectModal';
import './SubscriptionModal.css';

const SubscriptionModal = ({ person, selectedService, onClose }) => {
    const [selectedServiceId, setSelectedServiceId] = useState(selectedService?.id || person.services[0]?.id);
    const [showBooking, setShowBooking] = useState(false);

    const currentService = person.services.find(s => s.id === selectedServiceId);

    const handleSubscribe = () => {
        setShowBooking(true);
    };

    const handleBookingClose = () => {
        setShowBooking(false);
        onClose();
    };

    return (
        <div className="subscription-modal-overlay" onClick={onClose}>
            <div className="subscription-modal" onClick={e => e.stopPropagation()}>
                <button className="subscription-modal__close" onClick={onClose}>×</button>

                <div className="subscription-modal__header">
                    <img
                        src={person.primaryPhoto}
                        alt={person.name}
                        className="subscription-modal__avatar"
                    />
                    <div>
                        <h2 className="subscription-modal__title">Connect with {person.name}</h2>
                        <p className="subscription-modal__subtitle">{person.roles.join(' • ')}</p>
                    </div>
                </div>

                <div className="subscription-modal__services">
                    <h3>Choose a service</h3>
                    <div className="subscription-modal__service-list">
                        {person.services.map(service => (
                            <label
                                key={service.id}
                                className={`subscription-modal__service ${selectedServiceId === service.id ? 'subscription-modal__service--selected' : ''}`}
                            >
                                <input
                                    type="radio"
                                    name="service"
                                    value={service.id}
                                    checked={selectedServiceId === service.id}
                                    onChange={() => setSelectedServiceId(service.id)}
                                />
                                <div className="subscription-modal__service-info">
                                    <span className="subscription-modal__service-name">{service.name}</span>
                                    <span className="subscription-modal__service-desc">{service.description}</span>
                                </div>
                                <div className="subscription-modal__service-price">
                                    <span className="subscription-modal__service-amount">R {service.price}</span>
                                    <span className="subscription-modal__service-period">/{'once-off'}</span>
                                </div>
                            </label>
                        ))}
                    </div>
                </div>

                <div className="subscription-modal__includes">
                    <h3>What's included</h3>
                    <ul>
                        <li>✓ Direct access to {person.name}</li>
                        {currentService?.included?.map((item, index) => (
                            <li key={index}>✓ {item}</li>
                        ))}

                        {/* <li>✓ Cancel anytime</li> */}
                    </ul>
                </div>

                <button
                    className="subscription-modal__cta"
                    onClick={handleSubscribe}
                >
                    Connect
                </button>

                <p className="subscription-modal__disclaimer">
                    By subscribing, you agree to the terms of service. You can cancel anytime.
                </p>

                {showBooking && (
                    <ConnectModal
                        person={person}
                        service={currentService}
                        onClose={handleBookingClose}
                    />
                )}
            </div>
        </div>
    );
};

export default SubscriptionModal;
